import { render, staticRenderFns } from "./AuthorizedAcceptorSubmit.vue?vue&type=template&id=d222f43c"
import script from "./AuthorizedAcceptorSubmit.vue?vue&type=script&lang=js"
export * from "./AuthorizedAcceptorSubmit.vue?vue&type=script&lang=js"
import style0 from "./AuthorizedAcceptorSubmit.vue?vue&type=style&index=0&id=d222f43c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports